import React, { useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputDropdown from "../../../../../Shared/input-dropdown/inputDropdown";
import { IdsGenerator } from "../../../../../utils/idGenerator";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

const documentTypeOptions = ["invoice", "insurance"];
function DocumentProcessorPopup({ handleResponse }: any) {
  const errorObject = {
    documentFileError: false,
    documentTypeError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<any>("");
  const [documentType, setDocumentType] = useState<string>("invoice");
  const handleFileUpload = async (
    documentFile: any,
    documentType: string,
    consent: string
  ) => {
    const documentSideEncoded: any = await toBase64(documentFile);

    const char = ",";
    const frontIndex = documentSideEncoded.indexOf(char);
    const document_file =
      frontIndex !== -1 ? documentSideEncoded.substring(frontIndex + 1) : "";

    handleResponse({ document_file, documentType, consent }, setLoading);
  };

  function toBase64(image: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }

  function handleCheck() {
    if (!uploadedFile) {
      setError(() => ({
        ...error,
        documentFileError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    const consent = isChecked === true ? "Y" : "N";
    handleFileUpload(uploadedFile, documentType, consent);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4">
            <label className={`${Styles.label} flex-grow-1`}>
              Document File
            </label>
            <input
              id="id-input-file-ocr" data-testid="id-input-file-ocr"
              type="file"
              accept=".png,.jpeg,.jpg,.tif,.tiff,.pdf,.webp,application/pdf"
              onChange={(e: any) => setUploadedFile(e.target.files[0])}
              className={Styles.fileUpload}
            />
            {error.documentFileError && (
              <ErrorMessage>Please upload a file</ErrorMessage>
            )}
            <div className="d-flex my-4 w-50">
              <InputDropdown
                labelname="Document Type"
                hasError={error.documentTypeError}
                optionsArray={documentTypeOptions}
                defaultValue={documentType}
                default_value={documentType}
                click={(value: any) => {
                  setDocumentType(value);
                  setError((error) => ({
                    ...error,
                    documentTypeError: false,
                  }));
                }}
                id={IdsGenerator({
                  prefix: "document processor",
                  id: "select document type",
                  suffix: "dropdown",
                })}
              />
            </div>
          </div>
          <div className="pl-4 pb-4 mt-2 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input {...testIdProps("consent-checkbox-document-processor")}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-document-processor"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentProcessorPopup;
